/* eslint-disable camelcase */
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ActionButtonContainer, BodyPricingContainer, Column, DropdownHeader, EnterpriseHead, FeatureItem, FeatureList, Flex, Image, ImageFlexSection, PricingModalFooter, PricingPageFlexImage } from './payment-component';
import { Modal } from '../../common-components/modal';
import { API, API_URL, STATIC_PATH } from '../../constants/config';
import Typography from '../../common-components/Typography';
import { font } from '../../constants/font';
import { PLAN, PLAN_PRISING_RES, PLAN_TYPES, PRICING_MODAL_CONTENT } from '../../constants';
import PlanCard from './planCard';
import Action from '../../common-components/Action';
import { gpa } from '../../redux/actions/appUtils';
import useApi from '../../helper/hooks/useApi';
import { isEnterPrise, isPremiumUser, isTierPlan } from '../../helper/checkUser';
import PaymentModal from './paymentModal';
import useNotify from '../../helper/hooks/useNotify';
import { loadScript } from '../../helper/loadRazorpayScript';
import openUrl from '../../helper/openUrl';
import Contact from '../../animo-player/contact';
import { getLocalizedPlanPricing } from '../../helper/getLocalizedPlanPricing';
import PaymentSuccess from './paymentSuccess';
import BackdropLoader from '../../common-components/BackdropLoader';
import content from '../../constants/content';
import TogglePriceTab from '../../common-components/TogglePriceTab';
import useUpgrade from '../../helper/hooks/useUpgrade';
import { getSavingsAmount } from '../../helper/getSavingsAmount';


const filterData = (userPlan, userCycle, modalType) => {
    const planOrder = [PLAN.LITE, PLAN.STARTER, PLAN.TEAM, PLAN.ENTERPRISE];

    const isTeamTier = isTierPlan(userPlan);
    const effectivePlan = isTeamTier ? PLAN.TEAM : userPlan;
    const currentPlanIndex = planOrder.indexOf(effectivePlan);

    const currentPlanObj = PLAN_TYPES.find((item) => item.plan === userPlan);
    const nextPlan = planOrder[currentPlanIndex + 1];
    const nextPlanObj = PLAN_TYPES.find((item) => item.plan === nextPlan);

    // If on the highest plan, nothing to upgrade
    if (userPlan === PLAN.ENTERPRISE) {
        return [];
    }

    // Case 1: User is on a monthly plan (except Lite)
    // Suggest upgrade to same plan yearly + next plan monthly
    if (userCycle === "monthly" && userPlan !== PLAN.LITE) {
        const samePlanYearly = currentPlanObj
            ? { ...currentPlanObj, cycle: "yearly" }
            : null;

        const nextPlanMonthly = nextPlanObj
            ? { ...nextPlanObj, cycle: "monthly" }
            : null;

        return [samePlanYearly, nextPlanMonthly].filter(Boolean);
    }

    // Case 2: Modal-specific filtering
    switch (modalType) {
        case "poly":
            return PLAN_TYPES.filter(
                (item) =>
                    item.plan === PLAN.TEAM || item.plan === PLAN.ENTERPRISE
            );

        case "pipio":
            return PLAN_TYPES.filter(
                (item) =>
                    item.plan === PLAN.STARTER ||
                    item.plan === PLAN.TEAM ||
                    item.plan === PLAN.ENTERPRISE
            );

        default:
            // Default: Suggest next plan in both monthly & yearly cycles
            return PLAN_TYPES.filter((e) => planOrder.indexOf(e.plan) > currentPlanIndex);
    }
};


const PriceModal = () => {
    const [activeTab, setActiveTab] = useState(1);
    const [selectedTab, setSelectedTab] = useState("starter");
    const [currentCycle, setCurrentCycle] = useState("montly");
    const { plan } = useSelector((store) => store.userDetails);
    const { currentTeamId, username } = useSelector((state) => state.userDetails);
    const appReducer = useSelector((state) => state.app);
    const { country_code, country_name } = appReducer.get("ipConfig");
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [paymentSuccessModal, setPaymentSuccessModal] = useState(false);
    const { warn } = useNotify();
    const { post } = useApi();
    const [showContact, setShowContact] = useState(false);
    const [billingCycle, setBillingCycle] = useState("");
    const [monthlyAmount, setMonthlyAmount] = useState(0);
    const [yearlyAmount, setYearlyAmount] = useState(0);
    const [selectPlan, setSelectPlan] = useState("");
    const [paymentCycle, setPaymentCycle] = useState("yearly");
    const [showLoader, setShowLoader] = useState(false);
    const [regularPrice, setRegularPrice] = useState({});
    const [refundAmount, setRefundAmount] = useState(0);
    const [countryCode, setCountryCode] = useState(null);
    const [allPlanCurrency, setAllPlanCurrency] = useState(PLAN_PRISING_RES);
    const [paymentCurrency, setPaymentCurrency] = useState(null);
    const [cummulativePrice, setCummulativePrice] = useState(0);
    const [totalPayableAmount, setTotalPayableAmount] = useState(0);
    const [isEnterPrice, setIsEnterprice] = useState(false);
    const [save, setSave] = useState(25);
    const contextDetails = useSelector((state) => state.app.get("planDetails"));
    const { plan: current_plan } = useSelector((state) => state.userDetails);
    const { member_count, payment_mode, current_cycle } = contextDetails || {};
    const [modalData, setModalData] = useState(null);
    const [disableLoading, setDisableLoading] = useState(false);
    const { hidePricingModal } = useUpgrade();
    const {
        show,
        source,
        type,
        modalType
    } = useSelector((state) => state.app.get("showPricing").toJS()); // Class component dispatch modal
    // const { isShow } = useSelector((state) => state.app.get("upgrade").toJS());  // Functional component dispatch modal
    const [paymentDetails, setPaymentDetails] = useState({
        price: 0,
        maskedcc: 0,
        brand: "",
        binData: "",
        oldNonce: "",
    });
    // const modalData = (type || modalType) ? PRICING_MODAL_CONTENT[type || modalType] : PRICING_MODAL_CONTENT.default;
    const tabs = [{ label: "monthly" }, { label: "yearly" }];
    const [planCost, setPlanCost] = useState(PLAN_PRISING_RES);
    const [planData, setPlanData] = useState([]);
    const defaultSelectedPlan = PLAN.TEAM; // Default to Team plan

    const getPlansPricingDetails = (planName, type) => {
        setShowLoader(true);
        const proration = type === "downgrade" ? false : current_plan !== PLAN.LITE;
        const teamReq = {
            a: window.btoa(currentTeamId),
            b: window.btoa("upgrade"),
            c: window.btoa(proration),
            d: window.btoa(planName),
        };

        gpa(teamReq).then((res) => {
            if (!res.error) {
                const decodePrice =
                    window.atob(res.g) === "yearly"
                        ? window.atob(res.f)
                        : window.atob(res.e);
                const decodeMaskedcc = window.atob(res.a);
                const decodeBrand = window.atob(res.b);
                const decodeBd = window.atob(res.bd);
                const decodeNonce = window.atob(res.n);
                const decodeYearlyPrice = parseFloat(window.atob(res.f)).toFixed(2);
                const decodeMonthlyPrice = parseFloat(window.atob(res.e)).toFixed(2)
                const decodeRefund = parseFloat(window.atob(res.r)).toFixed(2);
                setYearlyAmount(Number(decodeYearlyPrice));
                setMonthlyAmount(Number(decodeMonthlyPrice));
                setRefundAmount(decodeRefund);
                const month = planCost[planName]?.monthly
                const yearly = planCost[planName]?.yearly
                const savePercentage = getSavingsAmount(month, yearly);
                const save = Math.round(savePercentage);
                setSave(save);

                const data = {
                    price: parseFloat(decodePrice),
                    maskedcc: parseFloat(decodeMaskedcc),
                    brand: decodeBrand,
                    binData: decodeBd,
                    oldNonce: decodeNonce,
                };
                setPaymentDetails(data);
                setShowPaymentModal(true);
                setShowLoader(false);
            } else {
                setShowLoader(false);
            }
        }).catch(() => {
            setShowLoader(false);
            warn(content.SOMETHING_WENT_WRONG);
        })
    };


    const upgradeHandler = (e, planName, tab, monthlyPrice) => {
        e && e.preventDefault() && e.stopPropagation();
        const planCycle = tab === 0 ? 'monthly' : 'yearly';
        setSelectedTab(planName);
        setPaymentCycle(planCycle);
        setBillingCycle(planCycle);
        setSelectPlan(planName);
        setIsEnterprice(isEnterPrise(planName));
        const month = planCost[planName]?.monthly
        const yearly = planCost[planName]?.yearly
        const savings = getSavingsAmount(month, yearly);
        setSave(savings);
        if (planCycle === "yearly") {
            const total = (monthlyPrice * 12) * member_count
            setTotalPayableAmount(total);
            setCummulativePrice(monthlyPrice * 12);
        } else {
            const total = monthlyPrice * member_count
            setTotalPayableAmount(total);
            setCummulativePrice(monthlyPrice);
        }
    }

    useEffect(() => {
        const planCycle = activeTab === 0 ? 'monthly' : 'yearly';
        setPaymentCycle(planCycle);
        setBillingCycle(planCycle);
        if (planCycle === "yearly") {
            const total = (monthlyAmount * 12) * member_count;
            setTotalPayableAmount(total);
            setCummulativePrice(monthlyAmount * 12);
        } else {
            const total = monthlyAmount * member_count;
            setTotalPayableAmount(total);
            setCummulativePrice(monthlyAmount);
        }
    }, [activeTab])

    const handleTab = (tab) => {
        if (activeTab === 0) {
            setActiveTab(1);
        } else {
            setActiveTab(0);
        }
        setCurrentCycle(tab === 0 ? "montly" : "yearly");
    }

    const handleShowPayment = () => {
        if ((selectedTab === "starter") && (current_plan === "starter") && (current_cycle === "monthly") && (activeTab === 0)) {
            warn("Please select plan");
        } else {
            getPlansPricingDetails(selectPlan);
        }
    }

    const handlePaymentCurrency = (currency) => {
        const staticData = currency === "USD" ? currency : "IN";
        const planCost = getLocalizedPlanPricing(allPlanCurrency, staticData);
        setPaymentCurrency(staticData);
        setRegularPrice(planCost);
    }

    const handleRazorpaySuccess = (payload, url) => {
        post(`${url}`, payload, true).then((res) => {
            setDisableLoading(true);
            setShowPaymentModal(false);
            setShowLoader(false);
            if (!res.error) {
                setPaymentSuccessModal(true);
            }
        }).catch(() => {
            setDisableLoading(true);
            setShowPaymentModal(false);
            setShowLoader(false);
        })
    }

    const handleRazorpayPayment = async (selectedPlan, planCycleName) => {
        await loadScript("https://checkout.razorpay.com/v1/checkout.js");
        const payload = {
            a: window.btoa(selectedPlan),
            b: window.btoa(planCycleName),
            g: window.btoa("Dashboard"),
            firstname: username
        };

        post(`${API_URL}${API.CREATE_RAZORPAY}`, payload, true).then((res) => {
            if (!res.error) {
                setDisableLoading(true);
                const options = {
                    key: res.key_id,
                    currency: "INR",
                    name: "Vmaker AI",
                    image: `${STATIC_PATH}vmakerai_logo.svg`,
                    description: res.plan_name,
                    subscription_id: res.subscription_id,
                    callbaclk_url: res.url,
                    redirect: false,
                    handler: (response) => {
                        try {
                            setShowLoader(true);
                            handleRazorpaySuccess(response, res.url)
                        } catch (err) {
                            console.error("Error verifying payment:", err);
                            warn(content.SOMETHING_WENT_WRONG);
                        }
                    },
                    modal: {
                        escape: false,
                        ondismiss() {
                            setDisableLoading(true);
                            setShowPaymentModal(false);
                            setShowLoader(false);
                            window.location.reload();
                        }
                    },
                    prefill: {
                        name: res.name,
                        email: res.email,
                    },
                    notes: {
                        address: "Soumya Dey Corporate Office",
                    },
                    theme: {
                        color: "#61dafb",
                    },
                };
                const rzp1 = new window.Razorpay(options);
                rzp1.open();
            } else if (res.error) {
                setDisableLoading(true);
                setShowPaymentModal(false);
                warn(res.msg || res.errormsg);
            }
        }).catch(() => {
            setDisableLoading(true);
            setShowPaymentModal(false);
            warn(content.SOMETHING_WENT_WRONG);
        })
    }

    const handlePaymentCard = (nonce, proration) => {
        const cycle = billingCycle || "yearly";
        const updateSource = source || "Editor";

        const payload = {
            a: window.btoa(selectPlan.toLowerCase()),
            b: window.btoa(cycle),
            g: window.btoa(updateSource),
            h: window.btoa(currentTeamId),
            n: window.btoa(nonce),
            ce: window.btoa(proration),
            cc: "",
            cdc: "",
        };

        post(`${API_URL}${API.CBTS}`, payload, true).then((res) => {
            if (!res.error) {
                if (PLAN.LITE === current_plan) {
                    localStorage.removeItem("coupon");
                }
                setDisableLoading(true);
                setShowPaymentModal(false);
                setPaymentSuccessModal(true);
            } else if (res.error) {
                warn(res.errormsg || res.msg);
                setDisableLoading(true);
                setShowPaymentModal(false);
            }
        }).catch(() => {
            setDisableLoading(true);
            setShowPaymentModal(false);
            warn(content.SOMETHING_WENT_WRONG);
        })
    };

    const handleCucCall = (url, nonce, change, couponStatus) => {
        post(url, {}).then((res) => {
            if (res.success) {
                handlePaymentCard(nonce, change, couponStatus);
            } else if (res.error) {
                warn(res.errormsg || res.msg);
                setShowPaymentModal(false);
                setDisableLoading(true);
            }
        }).catch(() => {
            setDisableLoading(true);
            setShowPaymentModal(false);
            warn(content.SOMETHING_WENT_WRONG);
        });
    }

    const handlePaypalPayment = (cycle) => {
        const payload = {
            a: window.btoa(selectPlan),
            b: window.btoa(cycle),
            g: window.btoa("Dashboard"),
            h: window.btoa(currentTeamId),
        };

        post(`${API_URL}${API.BUY_SUBSCRIPTION}`, payload, true).then((res) => {
            setDisableLoading(true);
            if (!res.error && res.redirect_url) {
                window.location.href = res.redirect_url;
            } else if (res.error) {
                warn(res.errormsg || res.msg);
            }
        }).catch(() => {
            setDisableLoading(true);
            warn(content.SOMETHING_WENT_WRONG);
        })
    }


    const handlePaymentBalance = (type, nonce, couponStatus) => {
        const cycle = billingCycle || "yearly";
        if (type === "paypal") {
            handlePaypalPayment(cycle);
        } else if (type === "razorpay") {
            const { selectPlan, planCycleName } = nonce;
            handleRazorpayPayment(selectPlan, planCycleName);
        } else if (type === "changeCard" || type === "card") {
            let url;
            let noncedata;
            if (type === "card") {
                url = `${API_URL}${API.PAYMENTS_PUC}`;
                noncedata = "";
            } else if (type === "changeCard") {
                url = `${API_URL}${API.PAYMENTS_CUC}`;
                noncedata = nonce;
            }
            const change = type === "card" ? 1 : 0;
            handleCucCall(url, noncedata, change, couponStatus);
        }
    };

    const handlePlanChange = (value) => {
        getPlansPricingDetails(value);
    };

    useEffect(() => {
        if (country_code && current_plan) {
            const code = (payment_mode === "bt" || payment_mode === "paypal") ? "US" : payment_mode === "razorpay" ? "IN" : country_code;
            setCountryCode(code);
            post(`${API_URL}${API.PLAN_PRISING}`, {}, false).then((res) => {
                if (res.data) {
                    const planCost = getLocalizedPlanPricing(res.data, code);
                    setPlanCost(planCost);
                    setAllPlanCurrency(res.data);
                    setRegularPrice(planCost || {});
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [country_code, current_plan]);

    useEffect(() => {
        if (plan) {
            const data = filterData(plan, current_cycle);
            setPlanData(data);
            if (data && data.length > 0) {
                // Try to find Team plan first, then fallback to defaultSelectedPlan, then first available plan
                const teamPlan = data.find((e) => e.plan === PLAN.TEAM);
                const defaultPlan = data.find((e) => e.plan === defaultSelectedPlan);
                const finalPlan = teamPlan || defaultPlan || data[0];
                setSelectedTab(finalPlan.plan);
                setSelectPlan(finalPlan.plan);
                
                const month = planCost[finalPlan.plan]?.monthly
                const yearly = planCost[finalPlan.plan]?.yearly
                const savePercentage = getSavingsAmount(month, yearly);
                const save = Math.round(savePercentage);
                setSave(save);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [plan, modalType]);

    const handleClose = () => {
        hidePricingModal();
        setShowContact(false);
    };

    const handleOnClose = useCallback(() => {
        setShowPaymentModal(false)
    }, [])

    useEffect(() => {
        if (current_plan) {
            if (current_cycle === "monthly") {
                setSelectPlan(current_plan);
            } else {
                const plan = current_plan === PLAN.LITE ? PLAN.STARTER : (current_plan === PLAN.STARTER && current_cycle === "yearly") ? PLAN.TEAM : current_plan;
                setSelectPlan(plan);
            }
        }
        if (current_cycle) {
            setActiveTab(1);
            setCurrentCycle(current_cycle);
        }
    }, [current_cycle, current_plan])

    const handleShowContact = () => {
        hidePricingModal();
        setShowContact(true);
    }

    useEffect(() => {
        if (type) {
            setModalData(PRICING_MODAL_CONTENT[type]);
        } else {
            setModalData(PRICING_MODAL_CONTENT.default);
        }
    }, [type]);

    let isUpgradeToEnterprise;

    switch (modalType) {
        case 'elevenlabs':
        case 'custom-avatar':
            isUpgradeToEnterprise = true;
            break;
        default:
            isUpgradeToEnterprise = isPremiumUser(current_plan);
            break;
    }

    return (
        <>
            {
                show && <Modal
                    onClose={(e) => handleClose(e)}
                    width={isUpgradeToEnterprise ? "888px" : "1012px"}
                    height={"auto"}
                    mobWidth="auto"
                    showModal={show}
                    className="payment--modal"
                    overflow="hidden"
                    borderRadius={"16px"}
                    smOverflow={"scroll"}
                    smHeight={"auto"}
                >
                    <Flex>
                        <Column className='flex-col' style={{ width: isUpgradeToEnterprise ? "50%" : "43%", height: "auto", padding: "0px 0px", borderRadius: "16px 0px 0px 16px" }}>
                            <ImageFlexSection >
                                <PricingPageFlexImage src={isUpgradeToEnterprise ? `${STATIC_PATH}${modalData?.enterpriseImage}` : `${STATIC_PATH}${modalData?.img}`} alt="pricing-image" />
                            </ImageFlexSection>

                        </Column>
                        {
                            isUpgradeToEnterprise ?
                                (<Column
                                    style={{
                                        width: "50%",
                                        padding: "32px 40px 16px",
                                        flexDirection: "column",
                                        display: "flex",
                                        gap: "2px"
                                    }}>
                                    <EnterpriseHead>
                                        <Image
                                            style={{ paddingBottom: "3px" }}
                                            src={`${STATIC_PATH}enterprise-icon.svg`}
                                        />

                                        <Typography
                                            height="20px"
                                            innerContent={"Enterprise Plan"}
                                            font={font.bold_16}
                                            color={"#313345"}
                                            display={"block"}
                                            padding={"0px 0px 0px 0px"}
                                            className="enterprise-section"
                                        />

                                    </EnterpriseHead>

                                    <Typography
                                        content={type === "resolutionExceed" ? content.ENTERPRISE_HIGHEST_QUALITY_MODAL : content.UPGRADE_CREDITS_AND_CUSTOM_FEATURES}
                                        color={"#313345"}
                                        font={font.normal_14_23}
                                        display={'block'}
                                        enableTrim={false} />

                                    <FeatureList>
                                        {(modalData?.enterpriseFeatures || []).map((feature) => (
                                            <FeatureItem key={feature}>
                                                <Typography content={feature} color={"#313345"} font={font.normalMini_14} />
                                            </FeatureItem>
                                        ))}
                                        <Action
                                            text={"Contact Us"}
                                            className="shared-btn"
                                            font={font.semi_bold_16}
                                            width={"100%"}
                                            height={"48px"}
                                            fontColor={"#FFFFFF"}
                                            onClick={() => { handleShowContact(true) }}
                                            marginBottom="16px"
                                            marginTop="32px"
                                            borderRadius={"12px"}
                                            isDisabled={!selectedTab}
                                            background={"#7353FF"}
                                            hoverColor={"#5F3BFF"} />
                                    </FeatureList>
                                </Column>) :
                                (
                                    <Column style={{
                                        width: "57%", flexDirection: "column",
                                        display: "flex"
                                    }}>

                                        <BodyPricingContainer >
                                            <Typography
                                                content={modalData.text}
                                                font={font.bold_20_26}
                                                color={"#313345"}
                                                display={"block"}
                                                padding={'0px 0px 16px'}
                                                enableTrim={false}
                                                className="pricingModalTitle"
                                            />

                                            <TogglePriceTab
                                                tabs={tabs}
                                                tabWidth={"242px"}
                                                height={"56px"}
                                                width={"100%"}
                                                activeTab={activeTab}
                                                save={isEnterPrice ? null : save}
                                                currentCycle={current_cycle === currentCycle}
                                                onTabChange={(newTab) => {
                                                    if (newTab !== activeTab) {
                                                        handleTab(newTab);
                                                    }
                                                }}
                                                disableTab={current_cycle === "yearly" ? 0 : null}
                                            />
                                            {/* <DropdownWrap> */}
                                            <DropdownHeader
                                                width={"492px"}
                                                height={"134px"}
                                                boxShadow={"0px 1px 8px #00BAFF3D"}
                                                border={"2px solid #00BAFF"}
                                                active={true}
                                            >
                                                {
                                                    planData.slice(0, 2).map((data) => {
                                                        return (
                                                            <PlanCard
                                                                key={data.name}
                                                                data={data}
                                                                planName={data.name}
                                                                titleSubtext={
                                                                    typeof modalData?.subText === "object"
                                                                        ? modalData?.subText?.[data?.plan] ?? ""
                                                                        : modalData?.subText ?? ""
                                                                }
                                                                iconSrc={data.icon}
                                                                // planContent={PLAN_CONTENT[data.plan]?.[type]}
                                                                action={data.action}
                                                                onClick={(e) => upgradeHandler(e, data.plan, activeTab, data.monthlyPrice)}
                                                                actionBgColor={data.actionBgColor}
                                                                // enterpriseContent={type === 'avatarVoice' ? data.avatarDescription : data.description}
                                                                // className={type === 'avatarVoice' ? 'avatarUpgrade' : ''}
                                                                monthlyPrice={!activeTab ?
                                                                    (planCost[data.plan]?.monthly ?? 0) :
                                                                    ((planCost[data.plan]?.yearly ?? 0) / 12)
                                                                }
                                                                yearlyPrice={activeTab ?
                                                                    (planCost[data.plan]?.monthly ?? 0) :
                                                                    ((planCost[data.plan]?.yearly ?? 0) / 12)
                                                                }
                                                                billingCycle={activeTab}
                                                                width={"100%"}
                                                                height={"134px"}
                                                                active={data.plan === selectedTab}
                                                                padding={"16px"}
                                                                cycleData={
                                                                    typeof modalData?.cycleData === "object"
                                                                        ? modalData?.cycleData?.[data?.plan] ?? null
                                                                        : modalData?.cycleData ?? null
                                                                }
                                                                countryCode={countryCode}
                                                                isDisabled={current_cycle === "monthly" && data.plan === current_plan && activeTab === 0}
                                                            />
                                                        )
                                                    })
                                                }
                                                <ActionButtonContainer>
                                                    <Action
                                                        text={"Pricing page"}
                                                        className="shared-btn"
                                                        font={font.largeBold_14}
                                                        onClick={() => openUrl("https://www.vmaker.com/pricing", true)}
                                                        width={"238px"}
                                                        height={"48px"}
                                                        fontColor={"#313345"}
                                                        borderRadius={"12px"}
                                                        background="#FFFFFF 0% 0% no-repeat padding-box"
                                                        borderColor="#E3E4E7"
                                                        borderWidth="1px "
                                                        // hoverColor={vmTheme[theme].secondaryBorderColor  }
                                                        showHoverColor={false}

                                                    />
                                                    {
                                                        isEnterPrice ? <Action
                                                            text={"Contact Us"}
                                                            className="shared-btn"
                                                            font={font.largeBold_14}
                                                            onClick={() => handleShowContact(true)}
                                                            width={"238px"}
                                                            height={"48px"}
                                                            fontColor={"#FFFFFF"}
                                                            borderRadius={"12px"}
                                                            background="#7353FF"
                                                        /> : <Action
                                                            text={"Upgrade"}
                                                            className="shared-btn"
                                                            font={font.largeBold_14}
                                                            onClick={() => handleShowPayment(true)}
                                                            width={"238px"}
                                                            height={"48px"}
                                                            fontColor={"#FFFFFF"}
                                                            borderRadius={"12px"}
                                                            background="transparent linear-gradient(101deg, #FF781A 0%, #F55322 100%) 0% 0% no-repeat padding-box"
                                                        />
                                                    }

                                                </ActionButtonContainer>
                                            </DropdownHeader>
                                        </BodyPricingContainer>
                                        {
                                            !isEnterPrice && <PricingModalFooter>
                                                <Typography
                                                    content={"Custom requirements? Explore our enterprise"}
                                                    font={font.normalBase_16}
                                                    color={"#313345"}
                                                    display={"block"}
                                                />
                                                <Typography
                                                    content={"Contact Sales!"}
                                                    font={font.boldBase_16}
                                                    color={"#FF781A"}
                                                    display={"block"}
                                                    textStyles={{ textDecoration: "underline" }}
                                                    cursor={"pointer"}
                                                    onClick={() => { handleShowContact(true) }}
                                                />
                                            </PricingModalFooter>
                                        }
                                    </Column>)
                        }
                    </Flex>
                </Modal>
            }

            {(showPaymentModal) && (
                <PaymentModal
                    isShow={showPaymentModal}
                    tenureEnable={true}
                    planDetails={paymentDetails}
                    billingCycle={billingCycle}
                    title={"Upgrade to Team Plan"}
                    onAction={handlePaymentBalance}
                    onClose={handleOnClose}
                    teamCount={member_count || 1}
                    planChange={handlePlanChange}
                    monthlyAmount={monthlyAmount}
                    yearlyAmount={yearlyAmount}
                    selectPlan={selectPlan}
                    refundAmount={refundAmount}
                    getBillingCycle={(value) => setBillingCycle(value)}
                    loadingDisable={disableLoading}
                    paymentMode={payment_mode}
                    defaultCycle={paymentCycle}
                    regularPrice={regularPrice}
                    countryCode={countryCode}
                    countryName={country_name}
                    changePaymentCurrency={handlePaymentCurrency}
                    paymentCurrency={paymentCurrency}
                    cummulative={cummulativePrice}
                    totalAmount={totalPayableAmount}
                    countryPin={countryCode}
                />
            )}
            {paymentSuccessModal && <PaymentSuccess message={`You’ve successfully upgraded to the ${selectPlan}`} />}
            {showLoader && <BackdropLoader content={"Please wait while the payment is processing..."} />}
            {showContact && <Contact setShowContact={setShowContact} />}
        </>
    );
};

export default PriceModal;